import { DownloadFile, enqueueSnackbar, UploadFile, UploadFiles, FetchDownloads } from 'actions';
import {
	GetClustersNamesRequest,
	GenerateShutdownReportRequest,
	GenerateShutdownReportV2Request
} from '../requests/Shutdown3gRequests';

export const SET_FORM_STATE = 'SET_FORM_STATE';
export const RESET_FIELDS = 'RESET_FIELDS';
export const GET_CLUSTERS_NAMES = 'GET_CLUSTERS_NAMES';

const onSetFormState = value => ({
	type: SET_FORM_STATE,
	formState: value
});

const onResetFields = () => ({
	type: RESET_FIELDS
});

const onGetClustersNames = value => ({
	type: GET_CLUSTERS_NAMES,
	clustersNames: value
});

export const SetFormState = value => dispatch => {
	dispatch(onSetFormState(value));
};

export const ResetFields = () => dispatch => {
	dispatch(onResetFields());
};

export const GetClustersNames = (userId) => async dispatch => {
	await GetClustersNamesRequest(userId)
		.then(response => {
			dispatch(onGetClustersNames(response.data));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const GenerateShutdownReport = (userId,  clusterName, shutdownDate, type) => async dispatch => {
	await GenerateShutdownReportRequest(userId, clusterName, shutdownDate, type)
		.then(response => {
			dispatch(DownloadFile(response.data));
			dispatch(enqueueSnackbar({ message: 'Report Complete', options: { variant: 'info' } }));

		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const GenerateShutdownV2Report = (userId,  clusterName, shutdownDate, postDate) => async dispatch => {
	await GenerateShutdownReportV2Request(userId, clusterName, shutdownDate, postDate)
		.then(response => {
			dispatch(DownloadFile(response.data));
			dispatch(enqueueSnackbar({ message: 'Report Complete', options: { variant: 'info' } }));

		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};
